import React from 'react';
import { Navigate } from 'react-router-dom';
import { FlexBoxFullWidth } from './components/common/boxes';
import Sidebar from './components/sidebar/Sidebar';
import { AUTH_PATH } from './router/paths';
import AppRouter from './router/AppRouter';
import { Box } from '@mui/material';

import { useAuthState } from './+state/useAuthState';

const App = () => {
  const { user } = useAuthState();
  return (
    <>
      {
        user
          ? <FlexBoxFullWidth height={'100vh'} width={'100vw'} overflow={'hidden'} maxWidth={2400} maxHeight={1800}>
            <Sidebar/>
            <Box py={5} flexGrow={1} width={'50%'} height={'100%'} sx={{ overflowX: 'hidden' }}
                 px={{ mobile: 3, tablet: 4 }}>
              <AppRouter/>
            </Box>
          </FlexBoxFullWidth>
          : <Navigate to={AUTH_PATH}/>
      }
    </>
  );
};

export default App;